import type { ReviewQuestionAnswer } from '@/types/review/ReviewAnswer';

import { api } from '@/api/api';

export default {
    async updateReviewQuestionAnswer(
        reviewQuestionAnswer: ReviewQuestionAnswer,
    ): Promise<ReviewQuestionAnswer> {
        const response = await api.put(
            `/reviewquestionanswer/${reviewQuestionAnswer.id}`,
            reviewQuestionAnswer,
        );
        return response.data;
    },

    async createReviewQuestionAnswer(
        reviewQuestionAnswer: ReviewQuestionAnswer,
    ): Promise<ReviewQuestionAnswer> {
        const response = await api.post(`/reviewquestionanswer`, reviewQuestionAnswer);
        return response.data;
    },
};
